import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/Home.vue';
import Prelaunch from '@/views/Prelaunch.vue';
import WelcomePage from '@/views/Welcome.vue';
import LeagueDetails from '@/views/LeagueDetails.vue';
import LeagueAdmin from '@/views/LeagueAdmin.vue';
import LeagueRace from '@/views/LeagueRace.vue';
import LeagueOverall from '@/views/LeagueOverall.vue';
import LeagueRaceTeam from '@/views/LeagueRaceTeam.vue';
declare var ga: Function;

Vue.use(VueRouter);

const routes = [
    {
        path: '/welcome',
        name: 'welcome',
        component: WelcomePage
    },
    {
        path: '/',
        name: 'registration',
        component: Prelaunch
    },
    {
        path: '/home',
        name: 'home',
        component: HomePage,
        props: { tab: 'my-team' }
    },

    {
        path: '/leagues',
        name: 'leagues',
        component: HomePage,
        props: { tab: 'leagues' }
    },
    {
        path: '/leagues/:id',
        name: 'league-details',
        component: LeagueDetails
    },
    {
        path: '/leagues/:id/overall',
        name: 'league-overall',
        component: LeagueOverall
    },
    {
        path: '/leagues/:id/admin',
        name: 'league-admin',
        component: LeagueAdmin
    },
    {
        path: '/leagues/:id/races/:raceid',
        name: 'league-race',
        component: LeagueRace
    },
    {
        path: '/leagues/:id/races/:raceid/team/:userid',
        name: 'league-race-team',
        component: LeagueRaceTeam
    }
];

// TODO - remove unused pages

const router = new VueRouter({
    // mode: 'history',
    routes
});

// Google Analytics Triggers
// router.afterEach((to, from) => {
//   ga('set', 'page', to.path);
//   ga('send', 'pageview');
// });

export default router;
